import type { Notification } from "@circle-react/types/Notification";

import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import { ActionsComponent } from "./ActionsComponent";
import { ActionsUIKitComponent } from "./ActionsUIKitComponent";

export interface ActionsProps {
  notification: Notification;
}

export const Actions = (props: ActionsProps) => {
  const isCircleV4 = useIsCircleV4FeatureEnabled("circle_v4_dropdown_enabled");

  if (isCircleV4) {
    return <ActionsComponent {...props} />;
  }

  return <ActionsUIKitComponent {...props} />;
};
